import { render } from "./MetricsWidget.vue?vue&type=template&id=d2d6efce&scoped=true"
import script from "./MetricsWidget.vue?vue&type=script&lang=js"
export * from "./MetricsWidget.vue?vue&type=script&lang=js"

import "./MetricsWidget.vue?vue&type=style&index=0&id=d2d6efce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d6efce"]])

export default __exports__